import { render } from "./NonDiscriminatoryPolicy.vue?vue&type=template&id=dd789a22"
import script from "./NonDiscriminatoryPolicy.vue?vue&type=script&lang=js"
export * from "./NonDiscriminatoryPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__